import React from 'react';
import styled from 'styled-components';

import { Burger, Logo } from '@lt/components/icons-react';

import { PartnerLogo } from '@lt/components/components/Logo';
import { isSSR } from 'src/helpers/ssr';
import type { HeaderProps } from './types';

const Header = ({
  redirectLogoLink = '/',
  onBurgerClick,
  partnerLogo,
  isHideMenu = false,
  isWhitelabel,
}: HeaderProps): JSX.Element | null => {
  if (isSSR && isWhitelabel) return null;
  return (
    <StyledHeader>
      {partnerLogo ? (
        <PartnerLogo src={partnerLogo.src} srcSet={partnerLogo.srcset} />
      ) : (
        <Link href={redirectLogoLink}>
          <StyledLogo />
        </Link>
      )}

      {!isHideMenu && (
        <Button type="button" onClick={onBurgerClick}>
          <StyledBurger />
        </Button>
      )}
    </StyledHeader>
  );
};
const StyledHeader = styled.div`
  font-size: var(--small-text-size);
  width: 100%;
  padding: 0 0 1.3em 1.3em;
  display: flex;
  justify-content: space-between;
  height: 4.45em;
  z-index: 2;

  // Чтобы PartnerLogo не провалилось под главную
  & a {
    z-index: 2;
  }

  & img {
    margin: 0;
  }
`;

const StyledBurger = styled(Burger)`
  height: 100%;
  z-index: 2;
  padding: 1.3em 1.3em 0;
`;

const StyledLogo = styled(Logo)`
  height: 100%;
  z-index: 2;
  padding: 1.3em 0 0;

  .logo_svg__text {
    fill: #fff;
  }
`;

const Link = styled.a`
  z-index: 2;
  height: 100%;
`;

const Button = styled.button`
  z-index: 2;
  height: 100%;
  border: none;
`;

export default Header;
